import React, { createContext, useContext, useEffect, useState } from "react";
import { loadSettings, SettingsMap } from "./api";

const Ctx = createContext<{ settings: SettingsMap; reload: () => Promise<void> }>({ settings: {}, reload: async () => {} });

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [settings, setSettings] = useState<SettingsMap>({});

  const reload = async () => {
    try { const s = await loadSettings(); setSettings(s); applyToDom(s); } catch { /* fallback to defaults */ }
  };
  useEffect(() => { reload(); }, []);

  return <Ctx.Provider value={{ settings, reload }}>{children}</Ctx.Provider>;
};

const applyToDom = (s: SettingsMap) => {
  const root = document.documentElement;
  if (s.primary_color) root.style.setProperty("--iav-blue", s.primary_color);
  if (s.background_color) root.style.setProperty("--iav-black", s.background_color);
  if (s.font_display) root.style.setProperty("--iav-font-display", `'${s.font_display}', sans-serif`);
  if (s.font_body) root.style.setProperty("--iav-font-body", `'${s.font_body}', sans-serif`);
  if (s.ga_tracking_id && !document.getElementById("ga4-script")) {
    const sc = document.createElement("script");
    sc.id = "ga4-script"; sc.async = true; sc.src = `https://www.googletagmanager.com/gtag/js?id=${s.ga_tracking_id}`;
    document.head.appendChild(sc);
    const inl = document.createElement("script"); inl.id = "ga4-inline";
    inl.text = `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments)}gtag('js',new Date());gtag('config','${s.ga_tracking_id}');`;
    document.head.appendChild(inl);
  }
};

export const useSettings = () => useContext(Ctx);
